var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "compare"
  }, [_vm.compareAmount ? _c('UIDataEntity', {
    staticClass: "compare__wrapper",
    attrs: {
      "get": _vm.$api.compare.getSection,
      "params": {
        products: _vm.compareIds
      }
    },
    on: {
      "success": _vm.onSuccess
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var loading = _ref.loading,
            error = _ref.error,
            success = _ref.success;
        return [error ? _c('StatusBlock', {
          attrs: {
            "content-width": "320px",
            "size": "l",
            "type": "error",
            "title": "Произошла ошибка"
          }
        }, [_vm._v("\n      Попробуйте воспользоваться страницей позднее или обновить её\n      "), _c('Button', {
          staticClass: "mt-15",
          attrs: {
            "fluid": "",
            "size": "39",
            "theme": "white"
          },
          on: {
            "click": _vm.reload
          }
        }, [_vm._v("\n        Обновить страницу\n      ")])], 1) : loading ? _c('StatusBlock', {
          staticClass: "compare__loader",
          attrs: {
            "size": "m",
            "type": "loading",
            "title": "Идёт загрузка"
          }
        }) : success ? [_vm.hasCompareList ? _c('div', [_c('UIDataEntity', {
          attrs: {
            "params": {
              id: _vm.activeTab,
              products: _vm.compareIds,
              cancel: true
            },
            "get": _vm.getRequest(_vm.activeTab)
          },
          on: {
            "success": _vm.onSuccessProduct
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var errorTab = _ref2.error,
                  loadingTab = _ref2.loading,
                  responseProduct = _ref2.response,
                  get = _ref2.get;
              return [_c('div', [_c('div', {
                staticClass: "compare__wrapper compare__wrapper_mobile"
              }, [!_vm.mobileActiveTab ? _c('div', {
                staticClass: "compare-tabs-wrapper compare-tabs-wrapper_mobile"
              }, [_c('div', {
                staticClass: "compare__tabs-header"
              }, [_c('h4', {
                staticClass: "compare__tabs-title"
              }, [_vm._v("\n                    Выберите категорию\n                  ")]), _vm._v(" "), _c('div', {
                staticClass: "compare__tabs-delete",
                on: {
                  "click": function ($event) {
                    _vm.modal.deleteAllProducts = true;
                  }
                }
              }, [_vm._v("\n                    Очистить\n                  ")])]), _vm._v(" "), _c('div', {
                staticClass: "compare-tabs"
              }, [_c('ul', {
                staticClass: "compare-tabs_list"
              }, _vm._l(_vm.list, function (category, index) {
                var _vm$categoriesCount;

                return _c('li', {
                  key: index,
                  staticClass: "compare-tabs__item fz-23",
                  on: {
                    "click": function ($event) {
                      _vm.onChangeTab({
                        category: category,
                        index: index
                      }), _vm.nextTick(function () {
                        return get({
                          id: category.id,
                          products: _vm.compareIds,
                          cancel: true
                        });
                      });
                    }
                  }
                }, [(_vm$categoriesCount = _vm.categoriesCount) !== null && _vm$categoriesCount !== void 0 && _vm$categoriesCount.length ? _c('div', [_vm._v("\n                        " + _vm._s(category.name) + " "), _c('span', {
                  staticClass: "compare-tabs__sup"
                }, [_vm._v(_vm._s(_vm.categoriesCount[index]))])]) : _vm._e(), _vm._v(" "), _c('div', {
                  staticClass: "compare-tabs__item-arrow"
                })]);
              }), 0)])]) : _vm.currentCategory ? _c('div', [errorTab ? _c('StatusBlock', {
                attrs: {
                  "content-width": "320px",
                  "size": "l",
                  "type": "error",
                  "title": "Произошла ошибка"
                }
              }, [_vm._v("\n                  Попробуйте воспользоваться страницей позднее или обновить её\n                  "), _c('Button', {
                staticClass: "mt-15",
                attrs: {
                  "fluid": "",
                  "size": "39",
                  "theme": "white"
                },
                on: {
                  "click": _vm.reload
                }
              }, [_vm._v("\n                    Обновить страницу\n                  ")])], 1) : loadingTab ? _c('StatusBlock', {
                attrs: {
                  "size": "l",
                  "type": "loading",
                  "title": "Идёт загрузка"
                }
              }) : _c('div', [_c('CompareHeaderMobile', {
                staticClass: "mb-16",
                attrs: {
                  "title": _vm.currentCategory.name,
                  "count": _vm.currentCategory ? _vm.currentCategory.quantity : undefined
                },
                on: {
                  "back": _vm.backToList,
                  "more": function ($event) {
                    _vm.modal.more = true;
                  },
                  "share": _vm.onShareClick,
                  "delete": function ($event) {
                    _vm.modal.more = false, _vm.modal.deleteCategoryProducts = true;
                  }
                }
              }), _vm._v(" "), _c('CompareTable', {
                attrs: {
                  "category-index": _vm.currentCategory.index || 0,
                  "products": responseProduct.result.product,
                  "properties": responseProduct.result.property,
                  "path": _vm.currentCategory.path
                },
                on: {
                  "compare-change-tab": function ($event) {
                    return _vm.handleChangeTab($event);
                  },
                  "compare-change-tab-count": function ($event) {
                    return _vm.handleChangeTabCount($event);
                  }
                }
              })], 1)], 1) : _vm._e()]), _vm._v(" "), _c('div', {
                staticClass: "compare__wrapper compare__wrapper_desktop",
                class: {
                  'compare__wrapper_slider-activated': _vm.isSliderShowButtons
                }
              }, [_c('div', {
                staticClass: "compare__title"
              }, [_c('h1', {
                staticClass: "h1"
              }, [_vm._v("\n                  Сравнение товаров\n                ")]), _vm._v(" "), _vm.getTotalCategoriesCount ? _c('span', {
                staticClass: "compare__title-sup"
              }, [_vm._v(_vm._s(_vm.getTotalCategoriesCount))]) : _vm._e()]), _vm._v(" "), _c('TabManager', {
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function () {
                    var _vm$list, _vm$currentCategory, _vm$currentCategory2;

                    return [(_vm$list = _vm.list) !== null && _vm$list !== void 0 && _vm$list.length ? _c('div', {
                      staticClass: "compare-tabs-wrapper",
                      class: [{
                        'compare-tabs-wrapper__without-tabs': !_vm.isShowTabs
                      }]
                    }, [_vm.isShowTabs ? _c('div', {
                      staticClass: "compare-tabs"
                    }, [_c('ul', {
                      directives: [{
                        name: "dragscroll",
                        rawName: "v-dragscroll",
                        value: true,
                        expression: "true"
                      }],
                      ref: "tabs",
                      staticClass: "compare-tabs_list",
                      on: {
                        "&scroll": function ($event) {
                          return _vm.overlayTabsHandler.apply(null, arguments);
                        }
                      }
                    }, _vm._l(_vm.list, function (category, index) {
                      var _vm$categoriesCount2;

                      return _c('li', {
                        key: index,
                        staticClass: "compare-tabs__item",
                        class: [{
                          active: _vm.activeTab == category.id
                        }],
                        on: {
                          "click": function ($event) {
                            $event.preventDefault();
                            _vm.onChangeTab({
                              category: category,
                              index: index
                            }), _vm.nextTick(function () {
                              return get({
                                id: category.id,
                                products: _vm.compareIds,
                                cancel: true
                              });
                            });
                          }
                        }
                      }, [_vm._v("\n                          " + _vm._s(category.name) + " "), (_vm$categoriesCount2 = _vm.categoriesCount) !== null && _vm$categoriesCount2 !== void 0 && _vm$categoriesCount2.length ? _c('span', {
                        staticClass: "compare-tabs__sup"
                      }, [_vm._v(_vm._s(_vm.categoriesCount[index]))]) : _vm._e()]);
                    }), 0), _vm._v(" "), _c('div', {
                      directives: [{
                        name: "show",
                        rawName: "v-show",
                        value: _vm.isOverlayTabsShow,
                        expression: "isOverlayTabsShow"
                      }],
                      staticClass: "compare-tabs__overlay"
                    })]) : _vm._e(), _vm._v(" "), _c('div', {
                      staticClass: "compare-actions"
                    }, [_c('div', {
                      staticClass: "compare-actions__item",
                      on: {
                        "click": _vm.onShareClick
                      }
                    }, [_c('div', {
                      staticClass: "compare-actions__item-icon-share"
                    }), _vm._v(" "), _c('span', [_vm._v("Поделиться")])]), _vm._v(" "), _c('div', {
                      staticClass: "compare-actions__item compare-actions__item_delete",
                      on: {
                        "click": function ($event) {
                          _vm.modal.deleteAllProducts = true;
                        }
                      }
                    }, [_c('div', {
                      staticClass: "compare-actions__item-icon-delete"
                    }), _vm._v(" "), _c('span', [_vm._v("Очистить все сравнение")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
                      directives: [{
                        name: "show",
                        rawName: "v-show",
                        value: _vm.activeTab,
                        expression: "activeTab"
                      }]
                    }, [errorTab ? _c('StatusBlock', {
                      attrs: {
                        "content-width": "320px",
                        "size": "l",
                        "type": "error",
                        "title": "Произошла ошибка"
                      }
                    }, [_vm._v("\n                      Попробуйте воспользоваться страницей позднее или обновить её\n                      "), _c('Button', {
                      staticClass: "mt-15",
                      attrs: {
                        "fluid": "",
                        "size": "39",
                        "theme": "white"
                      },
                      on: {
                        "click": _vm.reload
                      }
                    }, [_vm._v("\n                        Обновить страницу\n                      ")])], 1) : loadingTab ? _c('StatusBlock', {
                      attrs: {
                        "size": "l",
                        "type": "loading",
                        "title": "Идёт загрузка"
                      }
                    }) : _c('CompareTable', {
                      attrs: {
                        "category-index": ((_vm$currentCategory = _vm.currentCategory) === null || _vm$currentCategory === void 0 ? void 0 : _vm$currentCategory.index) || 0,
                        "products": responseProduct.result.product,
                        "path": (_vm$currentCategory2 = _vm.currentCategory) === null || _vm$currentCategory2 === void 0 ? void 0 : _vm$currentCategory2.path,
                        "properties": responseProduct.result.property
                      },
                      on: {
                        "compare-change-tab": function ($event) {
                          return _vm.handleChangeTab($event);
                        },
                        "compare-change-tab-count": function ($event) {
                          return _vm.handleChangeTabCount($event);
                        },
                        "share": _vm.onShareClick,
                        "delete-category": function ($event) {
                          _vm.modal.deleteCategoryProducts = true;
                        },
                        "delete-all": function ($event) {
                          _vm.modal.deleteAllProducts = true;
                        }
                      }
                    })], 1)];
                  },
                  proxy: true
                }], null, true)
              })], 1)])];
            }
          }], null, false, 278951308)
        }), _vm._v(" "), _c('SocialShare', {
          attrs: {
            "show": _vm.modal.share,
            "path": ("/compare/?shared=" + (_vm.compareIds))
          },
          on: {
            "close": function ($event) {
              _vm.modal.share = false;
            }
          }
        }), _vm._v(" "), _c('Modal', {
          attrs: {
            "show": _vm.modal.more
          },
          on: {
            "close": function ($event) {
              _vm.modal.more = false;
            }
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_c('div', {
                staticClass: "compare__delete-products-title"
              }, [_vm._v("\n              Выберите действие\n            ")])];
            },
            proxy: true
          }], null, false, 573129095)
        }, [_vm._v(" "), _c('div', {
          staticClass: "compare__modal-list"
        }, [_c('div', {
          staticClass: "compare__modal-list-el",
          on: {
            "click": _vm.onShareClick
          }
        }, [_c('div', {
          staticClass: "compare__modal-list-text"
        }, [_vm._v("\n                Поделиться\n              ")])]), _vm._v(" "), _c('div', {
          staticClass: "compare__modal-list-el",
          on: {
            "click": function ($event) {
              ;
              _vm.modal.more = false, _vm.modal.deleteCategoryProducts = true;
            }
          }
        }, [_c('div', {
          staticClass: "compare__modal-list-text"
        }, [_vm._v("\n                Очистить категорию\n              ")])])])]), _vm._v(" "), _c('ActionCompare', {
          on: {
            "success": function ($event) {
              _vm.list = [];
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref3) {
              var removeProducts = _ref3.removeProducts;
              return [_c('Modal', {
                attrs: {
                  "show": _vm.modal.deleteAllProducts,
                  "max-width": "360px"
                },
                on: {
                  "close": function ($event) {
                    _vm.modal.deleteAllProducts = false;
                  }
                },
                scopedSlots: _vm._u([{
                  key: "title",
                  fn: function () {
                    return [_c('div', {
                      staticClass: "compare__delete-products-title"
                    }, [_vm._v("\n                Очистка списка\n              ")])];
                  },
                  proxy: true
                }], null, true)
              }, [_vm._v(" "), _c('div', {
                staticClass: "compare__delete-products-content"
              }, [_c('p', {
                staticClass: "p"
              }, [_vm._v("\n                Вы хотите удалить все товары из сравнения?\n              ")]), _vm._v(" "), _c('div', {
                staticClass: "compare__delete-products-buttons"
              }, [_c('Button', {
                staticClass: "mr-15",
                on: {
                  "click": function ($event) {
                    removeProducts(), _vm.modal.deleteAllProducts = false;
                  }
                }
              }, [_vm._v("\n                  Удалить всё\n                ")]), _vm._v(" "), _c('Button', {
                attrs: {
                  "theme": "white"
                },
                on: {
                  "click": function ($event) {
                    _vm.modal.deleteAllProducts = false;
                  }
                }
              }, [_vm._v("\n                  Отменить\n                ")])], 1)])])];
            }
          }], null, false, 1111039974)
        }), _vm._v(" "), _c('ActionCompare', {
          on: {
            "success": _vm.onSuccessDeleteCategoryProducts
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref4) {
              var _vm$currentCategory3;

              var removeCategoryProducts = _ref4.removeCategoryProducts;
              return [_c('Modal', {
                attrs: {
                  "show": _vm.modal.deleteCategoryProducts,
                  "max-width": "395px"
                },
                on: {
                  "close": function ($event) {
                    _vm.modal.deleteCategoryProducts = false;
                  }
                },
                scopedSlots: _vm._u([{
                  key: "title",
                  fn: function () {
                    return [_c('div', {
                      staticClass: "compare__delete-products-title"
                    }, [_vm._v("\n                Удаление товаров категории\n              ")])];
                  },
                  proxy: true
                }], null, true)
              }, [_vm._v(" "), _c('div', {
                staticClass: "compare__delete-products-content"
              }, [_c('p', {
                staticClass: "p"
              }, [_vm._v("\n                Вы хотите удалить все товары из категории «" + _vm._s((_vm$currentCategory3 = _vm.currentCategory) === null || _vm$currentCategory3 === void 0 ? void 0 : _vm$currentCategory3.name) + "»?\n              ")]), _vm._v(" "), _c('div', {
                staticClass: "compare__delete-products-buttons"
              }, [_c('Button', {
                staticClass: "mr-15",
                on: {
                  "click": function ($event) {
                    return _vm.deleteCategoryProducts(removeCategoryProducts);
                  }
                }
              }, [_vm._v("\n                  Удалить\n                ")]), _vm._v(" "), _c('Button', {
                attrs: {
                  "theme": "white"
                },
                on: {
                  "click": function ($event) {
                    _vm.modal.deleteCategoryProducts = false;
                  }
                }
              }, [_vm._v("\n                  Отменить\n                ")])], 1)])])];
            }
          }], null, false, 2445895889)
        })], 1) : _vm._e()] : _vm._e()];
      }
    }], null, false, 4139826857)
  }) : _c('Unavailable', {
    attrs: {
      "icon": "compare"
    }
  }, [_c('div', {
    staticClass: "h3 mb-10"
  }, [_vm._v("\n      В сравнении нет товаров\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_vm._v("\n      Вы можете найти на сайте интересные товары и добавить их в список для сравнения\n    ")])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }